<template>
  <div class="form-group row mb-3 ">
    <label
      :for="id"
      v-if="label.length"
      class="col-sm-4 col-xl-3 col-form-label text-sm-end"
      v-text="label"
    />
    <div :class="{ 'col-sm-8 col-xl-9': label.length }">
      <div :class="{ 'input-group': hasCancelAction }">
        <select
          v-bind="$attrs"
          class="form-control"
          :class="{ 'is-invalid': errors }"
          :value="modelValue"
          @input="$emit('update:modelValue', $event.target.value)"
          ref="input"
        >
          <option disabled value>{{ disabledText }}</option>
          <option
            v-for="(option, optionIndex) in options"
            :key="optionIndex"
            :value="option.id"
            v-text="option.title"
          />
        </select>
        <button
          class="btn btn-sm btn-outline-secondary"
          @click.prevent="$emit('update:modelValue', '')"
          title="clear"
        >
          &times;
        </button>
      </div>
  
      <div
        v-if="errors"
        class="invalid-feedback d-block"
        v-html="displayErrors(errors)"
      />
    </div>
  </div>
</template>
<script>
export default {
  inheritAttrs: false,
  props: {
    modelValue: {
      type: [Number, String, Array],
      default: "",
    },
    options: {
      type: Array,
      default() {
        return [];
      },
    },
    id: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: false,
      default: "",
    },
    disabledText: {
      type: String,
      default: "Please select one",
    },
    hasCancelAction: {
      type: Boolean,
      default: true,
    },
    errors: {
      type: [String, Array],
      required: false,
      default() {
        return "";
      },
    },
  },

  emits: ["update:modelValue"],

  methods: {
    focus() {
      this.$refs.input.focus();
    },
  },
};
</script>
